<nav class="menu" role="navigation" id="sidebar-menu">
  <div class="sidebar-collapse">
    <ul class="nav" id="side-menu">
      <li>
        <app-news-display></app-news-display>
      </li>
      <mat-accordion>
        <li [ngClass]="{ active: urlInclude('#/recipe') || urlInclude('#/search') || urlInclude('recipes') }" [appAuth]="['RECIPE']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarRecipesLnk"
                ><i class="fa fa-list"></i> <span class="nav-label">{{ 'MENU.RECIPES' | translate }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['RECIPE.CREATE']">
                <a
                  class="menu-link"
                  id="SidebarRecipesNewLnk"
                  href="{{ links.newRecipeScreensEnable }}"
                  [ngClass]="{ active: urlInclude('/recipe') }"
                  >{{ 'MENU.RECIPES_NEW' | translate }}</a
                >
              </li>
              <li [appAuth]="['RECIPE.READ']">
                <a
                  class="menu-link"
                  id="SidebarRecipesSearchLnk"
                  (click)="handleRecipeSearchRedirect()"
                  [ngClass]="{ active: urlInclude('#/search') }"
                  >{{ 'MENU.SEARCH' | translate }}</a
                >
              </li>
              <!--              TODO en attente de l'evolution sur cette page-->
              <!--              <li [appAuth]="['RECIPE.CREATE']">-->
              <!--                <a class="menu-link" [routerLink]="'/recipes/copy-by-import'" [ngClass]="{'active':  urlInclude('recipes/copy-by-import')}" >{{ 'MENU.RECIPES_COPY' | translate }}</a>-->
              <!--              </li>-->
            </ul>
          </mat-expansion-panel>
        </li>

        <li [ngClass]="{ active: urlInclude('users') }" [appAuth]="['PROFILE']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarUsersNewBtn"
                ><i class="fa fa-user"></i> <span class="nav-label">{{ 'MENU.USERS' | translate }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['PROFILE.CREATE']">
                <a
                  class="menu-link"
                  [routerLink]="['/users/new']"
                  id="SidebarUsersNewLnk"
                  [ngClass]="{ active: urlInclude('/users/new') }"
                  >{{ 'MENU.USERS_NEW' | translate }}</a
                >
              </li>
              <li [appAuth]="['PROFILE.READ']">
                <a
                  class="menu-link"
                  id="SidebarUsersSearchLnk"
                  (click)="handleUserRedirect()"
                  [ngClass]="{ active: urlInclude('users/search') }"
                  >{{ 'MENU.SEARCH' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li [ngClass]="{ active: isModerationActive }" [appAuth]="['RECIPE.MODERATE', 'COMMENT.MODERATE']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarModerationBtn"
                ><i class="fa fa-comment"></i> <span class="nav-label">{{ 'MENU.MODERATION' | translate }}</span></mat-panel-title
              >
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['COMMENT.MODERATE']">
                <a
                  class="menu-link"
                  id="SidebarModerationCommentsLnk"
                  (click)="handleCommentRedirect()"
                  [ngClass]="{ active: urlInclude('moderation/comments') }"
                  >{{ 'MENU.MODERATION_COMMENTS' | translate }}</a
                >
              </li>
              <li [appAuth]="['RECIPE.MODERATE']">
                <a
                  id="SidebarModerationRecipesLnk"
                  class="menu-link"
                  href="/communities-recipes/search"
                  [ngClass]="{ active: urlInclude('/communities-recipes') }"
                  >{{ 'MENU.MODERATION_RECIPE' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li [ngClass]="{ active: urlInclude('#/references/packs') }" [appAuth]="['RECIPE']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarPacksNewBtn"
                ><i class="fa fa-folder"></i> <span class="nav-label">{{ 'MENU.PACKS' | translate }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['RECIPE.CREATE']">
                <a
                  class="menu-link"
                  id="SidebarPacksLnk"
                  (click)="handlePackRedirect()"
                  [ngClass]="{ active: urlInclude('/references/packs/new') }"
                  >{{ 'MENU.PACKS_NEW' | translate }}</a
                >
              </li>
              <li [appAuth]="['RECIPE.READ']">
                <a
                  class="menu-link"
                  id="SidebarPacksSearchLnk"
                  (click)="handleSearchPackRedirect()"
                  [ngClass]="{ active: urlInclude('#/references/packs/search') }"
                  >{{ 'MENU.PACKS_SEARCH' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li [ngClass]="{ active: urlInclude('#/contents') }" [appAuth]="['CONTENT']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarContentsBtn"
                ><i class="fa fa-list"></i> <span class="nav-label">{{ 'MENU.CONTENTS' | translate }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['CONTENT.CREATE']">
                <a
                  class="menu-link"
                  id="SidebarContentsNewLnk"
                  [routerLink]="'/contents/new'"
                  [ngClass]="{ active: urlInclude('#/contents/new') }"
                  >{{ 'MENU.CONTENTS_NEW' | translate }}</a
                >
              </li>
              <li [appAuth]="['CONTENT.READ']">
                <a
                  class="menu-link"
                  id="SidebarContentsSearchLnk"
                  [routerLink]="'/contents/search'"
                  [ngClass]="{ active: urlInclude('contents/search') }"
                  >{{ 'MENU.CONTENTS_SEARCH' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li [ngClass]="{ active: urlInclude('/references/techniques') }" [appAuth]="['RECIPE']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarCulinaryTechniquesBtn"
                ><i class="fa fa-utensils"></i>
                <span class="nav-label">{{ 'MENU.REFERENCES.TECHNIQUES.TITLE' | translate }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['RECIPE.CREATE']">
                <a
                  class="menu-link"
                  id="SidebarCulinaryTechniquesNewLnk"
                  href="#/references/techniques/new"
                  [ngClass]="{ active: urlInclude('#/references/techniques/new') }"
                  >{{ 'MENU.REFERENCES.TECHNIQUES.NEW' | translate }}</a
                >
              </li>
              <li [appAuth]="['RECIPE.READ']">
                <a
                  id="SidebarCulinaryTechniquesSearchLnk"
                  class="menu-link"
                  href="/references/techniques/search"
                  [ngClass]="{ active: urlInclude('/references/techniques/search') }"
                  >{{ 'MENU.REFERENCES.TECHNIQUES.SEARCH' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li [ngClass]="{ active: urlInclude('#/abacuses') }">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarCookingAbacusBtn"
                ><i class="fa fa-file-excel"></i> <span class="nav-label">{{ 'MENU.ABACUSES.TITLE' | translate }}</span></mat-panel-title
              >
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['RECIPE.CREATE']">
                <a
                  class="menu-link"
                  id="SidebarCookingAbacusImportExportLnk"
                  href="#/abacuses/landing"
                  [ngClass]="{ active: urlInclude('#/abacuses/landing') }"
                  >{{ 'MENU.ABACUSES.IMPORT_EXPORT' | translate }}</a
                >
              </li>
              <li [appAuth]="['RECIPE.READ']">
                <a
                  class="menu-link"
                  id="SidebarCookingAbacusSearchLnk"
                  href="#/abacuses/search"
                  [ngClass]="{ active: urlInclude('#/abacuses/search') }"
                  >{{ 'MENU.ABACUSES.SEARCH' | translate }}</a
                >
              </li>
              <li [appAuth]="['RECIPE.CREATE']">
                <a
                  class="menu-link"
                  id="SidebarCookingAbacusRecipeSkeletonsLnk"
                  href="#/abacuses/skeleton/search"
                  [ngClass]="{ active: urlInclude('#/abacuses/skeleton/search') }"
                  >{{ 'MENU.ABACUSES.TEMPLATE_RECIPES' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li>
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarDocumentationBtn"
                ><i class="fa fa-file-pdf"></i> <span class="nav-label">{{ 'MENU.DOCUMENTATION.TITLE' | translate }}</span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level collapse">
              <li *ngIf="APP_CONFIG.presentationDocLink">
                <a
                  class="menu-link"
                  id="SidebarDocumentationDcpPresentationLnk"
                  href="{{ APP_CONFIG.BOoldURL + '/' + APP_CONFIG.presentationDocLink }}"
                  >{{ 'MENU.DOCUMENTATION.PRESENTATION_DOC' | translate }}</a
                >
              </li>
              <li *ngIf="APP_CONFIG.appActivationToolkitDocLink">
                <a
                  class="menu-link"
                  id="SidebarDocumentationContentsAppsLnk"
                  target="_blank"
                  href="{{ APP_CONFIG.appActivationToolkitDocLink }}"
                  >{{ 'MENU.DOCUMENTATION.CONTENTS_FOR_APPS_DOC' | translate }}</a
                >
              </li>
              <li *ngIf="APP_CONFIG.recipeCreationDocLink">
                <a
                  class="menu-link"
                  id="SidebarDocumentationRecipesAppsLnk"
                  target="_blank"
                  href="{{ APP_CONFIG.recipeCreationDocLink }}"
                  >{{ 'MENU.DOCUMENTATION.RECIPE_CREATION_DOC' | translate }}</a
                >
              </li>
              <li *ngIf="APP_CONFIG.recipeManagementDocLink">
                <a
                  class="menu-link"
                  id="SidebarDocumentationRecipesWebsitesLnk"
                  target="_blank"
                  href="{{ APP_CONFIG.recipeManagementDocLink }}"
                  >{{ 'MENU.DOCUMENTATION.RECIPE_MANAGEMENT_DOC' | translate }}</a
                >
              </li>
              <li *ngIf="APP_CONFIG.aiLocalizationDocLink">
                <a
                  class="menu-link"
                  id="SidebarDocumentationManageRecipesLnk"
                  target="_blank"
                  href="{{ APP_CONFIG.aiLocalizationDocLink }}"
                  >{{ 'MENU.DOCUMENTATION.AI_LOCALIZATION_DOC' | translate }}</a
                >
              </li>
              <li *ngIf="APP_CONFIG.moderateCommentsAppsDocLink">
                <a
                  class="menu-link"
                  id="SidebarDocumentationModerateCommentsAppsLnk"
                  href="{{ APP_CONFIG.BOoldURL + '/' + APP_CONFIG.moderateCommentsAppsDocLink }}"
                  >{{ 'MENU.DOCUMENTATION.MODERATE_COMMENTS_APPS_DOC' | translate }}</a
                >
              </li>
              <li *ngIf="APP_CONFIG.importDocLink">
                <a
                  class="menu-link"
                  id="SidebarDocumentationImportDocLnk"
                  href="{{ APP_CONFIG.BOoldURL + '/' + APP_CONFIG.importDocLink }}"
                  >{{ 'MENU.DOCUMENTATION.IMPORT_DOC' | translate }}</a
                >
              </li>
              <li *ngIf="APP_CONFIG.importTplDocLink">
                <a
                  class="menu-link"
                  id="SidebarDocumentationImportTplLnk"
                  href="{{ APP_CONFIG.BOoldURL + '/' + APP_CONFIG.importTplDocLink }}"
                  >{{ 'MENU.DOCUMENTATION.IMPORT_TPL_DOC' | translate }}</a
                >
              </li>
              <li *ngIf="APP_CONFIG.abacusesDoc">
                <a class="menu-link" id="SidebarDocumentationAbacusDocLnk" href="{{ APP_CONFIG.abacusesDoc }}" target="_blank">{{
                  'MENU.DOCUMENTATION.ABACUSES_DOC' | translate
                }}</a>
              </li>
              <li *ngIf="APP_CONFIG.abacusesFormationDoc">
                <a
                  class="menu-link"
                  id="SidebarDocumentationAbacusFormationLnk"
                  href="{{ APP_CONFIG.abacusesFormationDoc }}"
                  target="_blank"
                  >{{ 'MENU.DOCUMENTATION.ABACUSES_FORMATION_DOC' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li [ngClass]="{ active: isAdministrationActive }" [appAuth]="['RECIPE.IMPORT_TRANSLATIONS', 'DATAREF', 'HISTORIZATION']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarAdministrationBtn"
                ><i class="fa fa-cogs"></i> <span class="nav-label">{{ 'MENU.REFERENCES.TITLE' | translate }}</span></mat-panel-title
              >
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['DATAREF.READ']">
                <a
                  class="menu-link"
                  id="SidebarAdministrationRefTablesLnk"
                  href="#/references/list"
                  [ngClass]="{ active: urlInclude('#/references/list') }"
                  >{{ 'MENU.REFERENCES.TABLES_LIST' | translate }}</a
                >
              </li>
              <li [appAuth]="['DATAREF.UPDATE']">
                <a
                  id="SidebarAdministrationTablesRefTraductionLink"
                  class="menu-link"
                  [routerLink]="['/administration/traduction/datarefs']"
                  [ngClass]="{ active: urlInclude('traduction/datarefs/') }"
                  >{{ 'MENU.REFERENCES.TRADUCTIONS_DATAREFS' | translate }}</a
                >
              </li>
              <li [appAuth]="['DATAREF.READ']">
                <a
                  class="menu-link"
                  id="SidebarAdministrationExportTablesRefLnk"
                  href="#/references/export/"
                  [ngClass]="{ active: urlInclude('#/references/export/') }"
                  >{{ 'MENU.REFERENCES.EXPORT' | translate }}</a
                >
              </li>
              <li [appAuth]="['RECIPE.IMPORT_TRANSLATIONS']">
                <a
                  class="menu-link"
                  id="SidebarDocumentationImportTraductionLnk"
                  href="#/translations/import"
                  [ngClass]="{ active: urlInclude('#/translations/import') }"
                  >{{ 'MENU.IMPORT_TRANSLATIONS' | translate }}</a
                >
              </li>
              <li [appAuth]="['DATAREF.READ']">
                <a
                  id="SidebarAdministrationImportDatarefSemanticsLnk"
                  class="menu-link"
                  href="#/references/semantic/import"
                  [ngClass]="{ active: urlInclude('#/references/semantic/import') }"
                  >{{ 'MENU.SEMANTIC_IMPORT' | translate }}</a
                >
              </li>
              <li [appAuth]="['DATAREF.READ']">
                <a
                  id="SidebarAdministrationImportDatarefSemanticsV2Lnk"
                  class="menu-link"
                  [routerLink]="['/administration/references/import-semantic']"
                  [ngClass]="{ active: urlInclude('/administration/references/import-semantic') }"
                  >{{ 'MENU.SEMANTIC_IMPORT_V2' | translate }}</a
                >
              </li>
              <li [appAuth]="['AUDIT.READ']">
                <a
                  class="menu-link"
                  id="SidebarAdministrationHistorisationLnk"
                  href="#/audit/search"
                  [ngClass]="{ active: urlInclude('#/audit/search') }"
                  >{{ 'MENU.REFERENCES.AUDIT' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li [ngClass]="{ active: urlInclude('#/applications') || urlInclude('/clients/') }" [appAuth]="['CLIENT.READ']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarClientsBtn"
                ><i class="fa fa-list-alt"></i> <span class="nav-label">{{ 'MENU.CLIENTS.TITLE' | translate }}</span></mat-panel-title
              >
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['CLIENT.READ']">
                <a
                  class="menu-link"
                  id="SidebarClientsListsLnk"
                  [routerLink]="['/clients/search']"
                  [ngClass]="{ active: urlInclude('/clients/search') }"
                  >{{ 'MENU.CLIENTS.LIST' | translate }}</a
                >
              </li>
              <li [appAuth]="['CLIENT.UPDATE']">
                <a
                  class="menu-link"
                  id="SidebarClientsNewLnk"
                  [routerLink]="['/clients/new']"
                  [ngClass]="{ active: urlInclude('/clients/new') }"
                  >{{ 'MENU.CLIENTS.NEW' | translate }}</a
                >
              </li>
              <!--              <li [appAuth]="['CLIENT.UPDATE']"><a class="menu-link" href="#/applications/new" [ngClass]="{'active':  urlInclude('#/applications/new')}">{{ 'MENU.CLIENTS.NEW' | translate }}</a></li>-->
              <li [appAuth]="['CLIENT.READ']">
                <a
                  class="menu-link"
                  id="SidebarClientsLocalsTableLnk"
                  href="#/applications/locales"
                  [ngClass]="{ active: urlInclude('#/applications/locales') }"
                  >{{ 'MENU.CLIENTS.LOCALES' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li [ngClass]="{ active: urlInclude('#/partners') }" [appAuth]="['RECIPE.READ']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarPartnersBtn"
                ><i class="fa fa-male"></i> <span class="nav-label">{{ 'MENU.PARTNERS.TITLE' | translate }}</span></mat-panel-title
              >
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['RECIPE.READ']">
                <a
                  class="menu-link"
                  id="SidebarPartnersSearchLnk"
                  [routerLink]="['/partners/search']"
                  [ngClass]="{ active: urlInclude('#/partners/search') }"
                  >{{ 'MENU.PARTNERS.SEARCH' | translate }}</a
                >
              </li>
              <li [appAuth]="['RECIPE.CREATE']">
                <a
                  class="menu-link"
                  id="SidebarPartnersNewLnk"
                  href="#/partners/new"
                  [ngClass]="{ active: urlInclude('#/partners/new') }"
                  >{{ 'MENU.PARTNERS.NEW' | translate }}</a
                >
              </li>
            </ul>
          </mat-expansion-panel>
        </li>

        <li [appAuth]="['RECIPE.READ']">
          <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false" class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title id="SidebarTipsCorrectionsBtn"
                ><i class="fa fa-photo-video"></i> <span class="nav-label">{{ 'MENU.SLIDESHOWS.TITLE' | translate }}</span></mat-panel-title
              >
            </mat-expansion-panel-header>
            <ul class="nav nav-second-level">
              <li [appAuth]="['RECIPE.READ']">
                <a class="menu-link" id="SidebarTipsCorrectionsSearchLnk" [routerLink]="['/slideshows/search']" routerLinkActive="active">{{
                  'MENU.SLIDESHOWS.SEARCH' | translate
                }}</a>
              </li>
              <li [appAuth]="['RECIPE.CREATE']">
                <a
                  class="menu-link"
                  id="SidebarTipsCorrectionsNewSlideshowLnk"
                  [routerLink]="['/slideshows/new']"
                  routerLinkActive="active"
                  >{{ 'MENU.SLIDESHOWS.NEW' | translate }}</a
                >
              </li>
              <li [appAuth]="['RECIPE.CREATE']">
                <a class="menu-link" id="SidebarTipsCorrectionsSlidesLnk" href="#/references/slides/search">{{
                  'MENU.SLIDESHOWS.SLIDES' | translate
                }}</a>
              </li>
            </ul>
          </mat-expansion-panel>
        </li>
      </mat-accordion>
    </ul>
  </div>
</nav>
